import store from '../../../cart/store';

export const getContactField = (phone, isRequired) => {
  const templates = store.getAdditionalInfoTemplates();
  return templates
    ? templates.contactPhone({phone: phone || '', isRequired})
    : '';
};
